export interface ChatNewMessage {
  message: string;
}

export interface ChatMessageDTO {
  id: number;
  tableId: string;
  userId: string;
  isPlayer: boolean;
  message: string;
  alias: string;
  // temporary fix for backwards compatibility
  createdAt: Date | string;
  isAdmin?: boolean;
  isTeamPro?: boolean;
}

export interface MutedUserResponse {
  tableId: string;
  userId: string;
  mutedUserIds: string[];
}

export interface ChatHistoryResponse {
  id: number;
  tableId: string;
  userId: string;
  alias: string;
  message: string;
  isPlayer: boolean;
  isAdmin?: boolean;
  isTeamPro?: boolean;
  createdAt: string;
}

export interface SystemMessageDTO {
  tableId: string;
  message: string;
  createdAt: Date;
  userId?: string;
  isPlayer?: boolean;
  alias?: string;
  id?: number;
  handId: string | null;
}
